import React from 'react';
import PropTypes from 'prop-types';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMConst from 'lib/SMConst';

class SMBillingList extends React.Component {

  renderOptionItems(items) {
    let rows = [];
    if (!items) items = [];
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      rows.push(
        <div key={item.id} className="reserve-detail-box">
          <h3 className="reserve-detail-box__title">オプション</h3>
          <p className="fl w500">{item.name}</p>
          <p className="fl">{SMFormatHelper.reservationOptionQuantity(item)}</p>
          <p className="fr">{item.total_amount_text}</p>
        </div>
      );
    }
    return rows;
  }

  renderOptionFoods(foods) {
    let rows = [];
    if (!foods) foods = [];
    for (let i = 0; i < foods.length; i++) {
      let food = foods[i];
      rows.push(
        <div key={food.id} className="reserve-detail-box">
          <h3 className="reserve-detail-box__title">飲食</h3>
          <p className="fl w500">{food.name}</p>
          <p className="fl">{SMFormatHelper.reservationOptionQuantity(food)}</p>
          <p className="fr">{food.total_amount_text}</p>
        </div>
      );
    }
    return rows;
  }

  renderChangedPrice(reservation) {
    if (reservation.billing.change_amount != 0.0) {
      return(
        <div className="reserve-detail-box">
          <p className="fl">価格変更({reservation.billing.change_description})</p>
          <p className="fr">{reservation.billing.change_amount_text}</p>
        </div>
      );
    }
    return null;
  }

  renderPointDiscount(reservation) {
    if (!this.props.isOwner && reservation.billing.is_applied_point) {
      return(
        <div className="reserve-detail-box">
          <p className="fl">ポイント割引</p>
          <p className="fr"><span className="is-minus">- {reservation.billing.point_discount_amount_text}</span></p>
        </div>
      );
    }
    return null;
  }

  renderLastMinuteDiscount(reservation) {
    if (reservation.is_last_minute_discount) {
      return(
        <div className="reserve-detail-box">
          <p className="fl">直前割</p>
          <p className="fr"><span className="is-minus">- {reservation.billing.last_minute_discount_amount_except_tax_text}</span></p>
        </div>
      );
    }
    return null;
  }

  renderDiscount(reservation) {
    if (!this.props.isOwner && reservation.billing.is_applied_coupon) {
      return(
        <div className="reserve-detail-box">
          <p className="fl">クーポン割引</p>
          <p className="fr"><span className="is-minus">- {reservation.billing.discount_amount_text}</span></p>
        </div>
      );
    }
    return null;
  }

  renderPlan(reservation) {
    //let planName = reservation.plan ? reservation.plan.plan_name : "基本プラン";
    let planName = SMFormatHelper.planName(reservation.plan);

    let rows = [];
    // ToDo: 時間ごとに金額がバラバラなので表示方法を検討
    // for (let i = 0; i < reservation.reserved_schedules.length; i++) {
    //   let schedule = reservation.reserved_schedules[i];
    //   rows.push(
    //     //<p key={schedule.id} className="fl">{SMFormatHelper.duration(schedule.duration)}</p>
    //   );
    //   //<p className="fl">¥1,500/時間 ×3</p>
    // }
    return(
      <div className="reserve-detail-box">
        <h3 className="reserve-detail-box__title">スペース利用料</h3>
        <p className="fl w500">{planName}</p>
        {rows}
        <p className="fr">{reservation.billing.room_amount_text}</p>
      </div>
    );
  }

  renderSalesTax(reservation) {
    return(
      <div className="reserve-detail-box">
        <p className="fl">消費税</p>
        <p className="fr">{this.props.isOwner ? reservation.billing.sales_tax_text
                                              : reservation.billing.guest_sales_tax_text}</p>
      </div>
    );
  }

  renderSubTotal(reservation) {
    if (this.props.isOwner ||
        reservation.billing.guest_total_amount_with_tax === reservation.billing.total_pay_amount_for_user_with_tax ||
        !reservation.billing.is_applied_coupon) {
      return null;
    }

    return(
      <div className="reserve-detail-box reserve-detail-box__sum">
        <p className="fl">小計</p>
        <p className="fr">{reservation.billing.guest_total_amount_with_tax_text}</p>
      </div>
    );
  }

  renderTotal(reservation) {
    return(
      <div className="reserve-detail-box reserve-detail-box__sum">
        <p className="fl">合計</p>
        <p className="fr">{this.props.isOwner ? reservation.billing.total_amount_with_tax_text
                                              : reservation.billing.total_pay_amount_for_user_with_tax_text}</p>
      </div>
    );
  }

  renderGuestFee(reservation) {
    if (reservation.billing.guest_fee_amount == 0.0) {
      return null;
    }

    if (!this.props.isOwner && reservation.billing.guest_fee_amount_text) {
      return(
        <div className="reserve-detail-box">
          <p className="fl">サービス料</p>
          <p className="fr">{reservation.billing.guest_fee_amount_text}</p>
        </div>
      );
    }
    return null;
  }

  renderGuestPostpayFee(reservation) {
    if (!this.props.isOwner && reservation.billing.payment_method === SMConst.PaymentMethod.Postpay) {
      return(
        <div className="reserve-detail-box">
          <p className="fl">後払い手数料</p>
          <p className="fr">{reservation.billing.guest_postpay_fee_amount_text}</p>
        </div>
      );
    }
  }

  renderPoint(reservation) {
    if (this.props.isOwner || !reservation.point_amount_text) {
      return null;
    }
    return (
      <p className="reserve-detail__point">このスペース利用で<span className="reserve-detail__point-have">{reservation.point_amount_text}</span>ポイント獲得予定です。</p>
    );
  }

  render() {
    let reservation = this.props.reservation;
    if (!reservation.billing) return null;
    return (
      <div>
        {this.renderPlan(reservation)}
        {this.renderOptionItems(reservation.reserved_option_items)}
        {this.renderOptionFoods(reservation.reserved_option_foods)}
        {this.renderChangedPrice(reservation)}
        {this.renderLastMinuteDiscount(reservation)}
        {this.renderGuestFee(reservation)}
        {this.renderPointDiscount(reservation)}
        {this.renderGuestPostpayFee(reservation)}
        {this.renderSalesTax(reservation)}
        {this.renderSubTotal(reservation)}
        {this.renderDiscount(reservation)}
        {this.renderTotal(reservation)}
        {this.renderPoint(reservation)}
      </div>
    );
  }
}

SMBillingList.propTypes = {
  reservation: PropTypes.object.isRequired,
  isOwner: PropTypes.bool.isRequired,
};
export default SMBillingList;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMBillingList.jsx